import { StoreCalendarType } from 'types/storeCalendar'
import { OrderedDate } from 'types/calendar'

export const SET_STORE_CURRENT_MONTH = 'SET_STORE_CURRENT_MONTH'
export const setStoreCurrentMonthAction = (date: Date) => {
  return {
    type: 'SET_STORE_CURRENT_MONTH',
    payload: date,
  }
}

export const SET_CLOSED_STORE_CALENDARS = 'SET_CLOSED_STORE_CALENDARS'
export const setClosedStoreCalendarsAction = (dates: Date[]) => {
  return {
    type: 'SET_CLOSED_STORE_CALENDARS',
    payload: dates,
  }
}

export const SET_ORDERED_STORE_CALENDARS = 'SET_ORDERED_STORE_CALENDARS'
export const setOrderedStoreCalendarsAction = (orderedDates: OrderedDate[]) => {
  return {
    type: 'SET_ORDERED_STORE_CALENDARS',
    payload: orderedDates,
  }
}

export const SET_STORE_CALENDARS = 'SET_STORE_CALENDARS'
export const setStoreCalendarsAction = (storeCalendars: StoreCalendarType[]) => {
  return {
    type: 'SET_STORE_CALENDARS',
    payload: storeCalendars,
  }
}

export const INIT_STORE_CALENDAR = 'INIT_STORE_CALENDAR'
export const initStoreCalendarAction = () => {
  return {
    type: 'INIT_STORE_CALENDAR',
    payload: null,
  }
}
